<div class="profile-preferences-container container default-padding" fxLayout="column" fxLayoutGap="15px">
  <mtn-simple-panel color="blue">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <fa-icon icon="info-circle"></fa-icon>
      <span>{{ 'PROFILE_PREFS.AutoSaveMessage' | translate }}</span>
    </div>
  </mtn-simple-panel>
  <ng-template #spinner>
    <div class="spinner-container">
      <mtn-spinner [on]="true" [size]="SpinnerSize.MEDIUM"></mtn-spinner>
    </div>
  </ng-template>
  <div class="preferences-container container" [formGroup]="form" *ngIf="preferences; else spinner" fxLayout="column"
       fxLayoutGap="30px">
    <div fxLayout="column">
      <h3 class="mat-h3 color-primary">{{ 'PROFILE_PREFS.KeyIndicatorTitle' | translate }}</h3>
      <div class="panel-container container" fxFlex fxLayout="column" fxLayoutGap="15px">
        <p>{{Dictionary.labelKeyIndicatorPreferenceDescription}}</p>
        <mat-radio-group color="primary" formControlName="primaryKeyIndicator" fxLayout="column" fxLayoutGap="5px">
          <mat-radio-button [value]="KeyIndicatorType.SALES_SQFT">{{ 'PROFILE_PREFS.SalesPerSqft' | translate }}</mat-radio-button>
          <mat-radio-button [value]="KeyIndicatorType.SALES_VOLUME">{{ 'PROFILE_PREFS.SalesVolume' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div fxLayout="column">
      <h3 class="mat-h3 color-primary">{{ 'PROFILE_PREFS.MapSettingsTitle' | translate }}</h3>
      <div class="panel-container container" fxLayout="row" fxLayoutGap="15px">
        <div class="map-preferences-container container" fxFlex fxLayout="column">
          <p>{{Dictionary.labelMapDefaultModePreferenceDescription}}</p>
          <mat-radio-group formControlName="mapDefaultMode" fxLayout="column" fxLayoutGap="5px" color="primary">
            <mat-radio-button [value]="MapMode.CLASSIC">{{ 'PROFILE_PREFS.MapModeClassic' | translate }}</mat-radio-button>
            <mat-radio-button [value]="MapMode.DARK">{{ 'PROFILE_PREFS.MapModeDark' | translate }}</mat-radio-button>
          </mat-radio-group>
          <br/>
          <p>{{Dictionary.labelMapDefaultTypePreferenceDescription}}</p>
          <mat-radio-group formControlName="mapDefaultType" fxLayout="column" fxLayoutGap="5px" color="primary">
            <mat-radio-button [value]="MapTypeId.ROADMAP">{{ 'PROFILE_PREFS.MapTypeRoad' | translate }}</mat-radio-button>
            <mat-radio-button [value]="MapTypeId.HYBRID">{{ 'PROFILE_PREFS.MapTypeSatellite' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <p class="color-muted">{{ 'PROFILE_PREFS.Example' | translate }}</p>
          <div class="map-container container">
            <mtn-map [options]="mapOptions" *ngIf="mapOptions" (ready)="onMapReady($event)"></mtn-map>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="column">
      <h3 class="mat-h3 color-primary">{{ 'PROFILE_PREFS.SalesVolumeDisplayTitle' | translate }}</h3>
      <div class="panel-container container" fxFlex fxLayout="column" fxLayoutGap="15px">
        <p>{{Dictionary.labelSalesVolumePreferenceDescription}}</p>
        <mat-radio-group color="primary" formControlName="salesVolumeDisplayMode" fxLayout="column" fxLayoutGap="5px">
          <mat-radio-button [value]="SalesVolumeDisplayModeType.ANNUAL">{{ 'PROFILE_PREFS.AnnualSales' | translate }}</mat-radio-button>
          <mat-radio-button [value]="SalesVolumeDisplayModeType.WEEKLY">{{ 'PROFILE_PREFS.WeeklySales' | translate }}</mat-radio-button>
        </mat-radio-group>
        <div class="container">
          <p class="color-muted">{{ 'PROFILE_PREFS.Example' | translate }}</p>
          <mtn-sales-volume-view [volume]="sampleVolume"></mtn-sales-volume-view>
        </div>
      </div>
    </div>
    <div fxLayout="column">
      <h3 class="mat-h3 color-primary">{{ 'PROFILE_PREFS.SalesSqftDisplayTitle' | translate }}</h3>
      <div class="panel-container container" fxFlex fxLayout="column" fxLayoutGap="15px">
        <p>{{Dictionary.labelSalesSqftPreferenceDescription}}</p>
        <mat-radio-group color="primary" formControlName="salesSqftDisplayMode" fxLayout="column" fxLayoutGap="5px">
          <mat-radio-button [value]="SalesSqftDisplayModeType.SALES_AREA">{{ 'PROFILE_PREFS.UseSalesArea' | translate }}</mat-radio-button>
          <mat-radio-button [value]="SalesSqftDisplayModeType.TOTAL_AREA">{{ 'PROFILE_PREFS.UseTotalArea' | translate }}</mat-radio-button>
        </mat-radio-group>
        <div class="container">
          <p class="color-muted">{{ 'PROFILE_PREFS.Example' | translate }}</p>
          <mtn-sales-sqft-view [volume]="sampleVolume"></mtn-sales-sqft-view>
        </div>
      </div>
    </div>
  </div>
</div>
